// PWA service worker registration
export function registerSW() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Only register in production-like environments (HTTPS or localhost)
  const isSecure = window.location.protocol === "https:" || window.location.hostname === "localhost";
  if (!isSecure) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[PWA] SW registration failed:", err);
      });
  });
}
